import { useCallback } from "react";

import { ROUTES } from "@/constants";
import { useAppSelector } from "@/hooks";
import { Header } from "@/shared/layout";
import { Meta } from "@/shared/seo";

import { MultiSelectorHeader } from "../../components/MultiSelectorHeader";
import { useScheduleSelection } from "../../hooks";
import {
    RouteEditorModal,
    RouteEditorModalState,
} from "../../RouteEditor.types";

export type RouteEditorCreateMetaAndHeaderBlockProps = {
    selection: ReturnType<typeof useScheduleSelection>;
    onSetModalState: (state: RouteEditorModalState) => void;
};

export const RouteEditorCreateMetaAndHeaderBlock = ({
    selection,
    onSetModalState,
}: RouteEditorCreateMetaAndHeaderBlockProps) => {
    const currentScheduleList = useAppSelector(
        (s) => s.manager.currentScheduleList,
    );

    const handleOpenDeleteModal = useCallback(() => {
        const selectedPointIds = selection.selectedSchedules.map(
            ({ pointId }) => pointId,
        );

        onSetModalState({
            type: RouteEditorModal.DeleteSchedule,
            payload: {
                pointIds: selectedPointIds,
                isEmptyAfterDelete:
                    currentScheduleList.length === selectedPointIds.length,
                createMode: true,
            },
        });
    }, [
        currentScheduleList.length,
        onSetModalState,
        selection.selectedSchedules,
    ]);

    return (
        <>
            <Meta title="Редагувати маршрут" />
            {selection.multiSelectMode ? (
                <MultiSelectorHeader
                    selectedCount={selection.selectedSchedules.length}
                    allSelected={
                        selection.sortedAndFilteredSchedules.length ===
                        selection.selectedSchedules.length
                    }
                    onSelectAllItems={selection.handleSelectAll}
                    onClearSelection={selection.handleClearSelection}
                    onExitSelectionMode={selection.exitMultiSelectMode}
                    onDeleteSelected={handleOpenDeleteModal}
                />
            ) : (
                <Header
                    title="Створити маршрут"
                    path={ROUTES.RouteManagement}
                />
            )}
        </>
    );
};
